import {useEffect,useContext} from 'react'
import {
  Image,
  Text,
  Link,
  VStack,
  Button,
  CloseIcon
} from "native-base";
import StyledButton from '../../../components/Button/index'
import { useNavigate } from "react-router-dom";
import useScrollToTop from '../../../hooks/useScrollToTop'
import { AppContext } from '../../../context';

function UpcycleLaMakanerie() {
  const scrollToTop = useScrollToTop();
  const { getData,getParams} = useContext(AppContext);
  const acqua_design = require('../../../images/dressThreeUpcycle.png');
  const amarezza_design = require('../../../images/amarezza/Acv.png');

  var endImage = require('../../../images/dressOneEndLife.png');
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);
  return (
    <>
        <VStack alignItems="flex-start" space={0} px={"4"} paddingTop={'4'}>
        <Button onPress={() => navigate(-1)} variant={'unstyled'}><CloseIcon 
        color={
          getParams.style ==='acqua'? '#B03D01' : 
          getParams.style ==='amarezza'? '#DCA459D0':'#000000'
        }
         size={"5"}/></Button>
        </VStack>
        <VStack alignItems={"center"} px={4} space={0}>
          <Text color={"#000000"} fontSize={"4xl"} fontWeight={'500'} fontFamily={'AttilaSansBasic Regular'}>Upcycle</Text>
        </VStack>
        <VStack alignItems={"center"} marginBottom={"4"} px={4} space={18} marginTop={'24px'}>
        <Text color={"##000000"} fontSize={'12px'} fontWeight={'300'} fontFamily="AttilaSansBasic Light">
        Notre partenaire Tilli met son service Upcycling à votre disposition. Donnez une seconde vie à votre foulard et créez une chemise, une cravate... il y a plein d'options !
          </Text>
        </VStack>
        <VStack alignItems={"center"} px={4} py={2}>  
        <Link href="https://tilli.fr/reserver-votre-couturier-a-domicile/" width={'full'}>
               <StyledButton
              text={'Upcycler votre foulard'}
              fontFamily="AttilaSansBasic Light"
              backgroundColor={ getParams.style ==='acqua' ? "#B03D01" : '#DCA459'}
             textColor="#FFFFFF"
            borderColor="transparent"
            width="100%"
            height="54px"
           hoverBackgroundColor="#FFFFFF"
           hoverTextColor={ getParams.style ==='acqua' ? "#B03D01" : '#DCA459'}
           hoverBorderColor={ getParams.style ==='acqua' ? "#B03D01" : '#DCA459'}
          />
          </Link>
          {/* <Button width="full" borderColor="#1341B6" marginBottom={4}>
          Get your shipping label
        </Button> */}
        </VStack>
        <VStack alignItems={'center'} marginTop={'24px'}>
        <Image
              source={{ uri: getParams.style ==='amarezza'? amarezza_design: getParams.style === 'acqua'? acqua_design :'' }}
              alt="Alternate Text"
              size="xl"
              width="full"
              height="535px"
          />
        </VStack>

        </>
  );
}

export default UpcycleLaMakanerie;
